import React from 'react';
import LocationTemplate from './LocationTemplate';

const AutryvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Autryville"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28318"]}
      latitude={35.0085}
      longitude={-78.638}
      population={196}
      historicalFact="Small town in Sampson County incorporated in 1891."
      nearbyTowns={[
        "Clinton, NC",
        "Roseboro, NC",
        "Salemburg, NC",
        "Dunn, NC",
        "Garland, NC",
        "Fayetteville, NC",
        "Godwin, NC",
        "Wade, NC"
      ]}
    />
  );
};

export default AutryvillePage;